import http from 'plugins/axios';

export default {
  types() {
    return http.get({ url: '/ta/admin/tenant/public-subject/types' });
  },
  list({ userType, coin = 'USDT' } = {}) {
    let url = `/ta/admin/tenant/public-subject/balance/list?coin=${coin}`;
    if (userType != null && userType !== '') {
      url += `&userType=${userType}`;
    }
    return http.get({ url });
  },
  billDetail({
    userId,
    coin = 'USDT',
    period = 'TODAY',
    counterpartyUserId = '',
    page = 1,
    size = 20,
  } = {}) {
    let url = `/ta/admin/tenant/public-subject/balance/bill-detail?userId=${userId}&coin=${coin}&period=${period}&page=${page}&size=${size}`;
    if (counterpartyUserId !== '' && counterpartyUserId != null) {
      url += `&counterpartyUserId=${counterpartyUserId}`;
    }
    return http.get({ url });
  },
};
